<template>
    <div class="tag-list-layout">
        <div
            class="tag-box"
            v-for="tag in tagList"
            :key='tag'
        >
            <span>{{tag}}</span>
        </div>
    </div>
</template>

<script>
export default {
  props: {
    tagList: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang="scss" scoped>
.tag-list-layout {
    display:flex;
}

.tag-box {
    padding: 3px 10px 4px;
    border: 1px solid $main-color-light;
    border-radius: 16px;
    @include displayCenter;
    color: $main-color-light;
    box-sizing: border-box;
    margin-left: 16px;
    span {
        @include text-20-400;
        font-size: 14px;
    }
}

.tag-box + .tag-box {
    margin-left: 12px;
}
</style>
